import {
    createStore,
    compose,
    applyMiddleware,
    Middleware,
    //   MiddlewareAPI,
    AnyAction,
    Dispatch,
} from 'redux';

import { routerMiddleware } from 'connected-react-router';

import { History } from 'history';

import rootReducer from './reducers';
// import { SagaMiddleware } from 'redux-saga';

import { actionCreators as layoutActionCreators } from './reducers/Layout';
import { Store } from 'redux';

import SignalRHandler from './messaging/SignalRHandler';

interface IAppWindow extends Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: Function;
}
declare let window: IAppWindow;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const setState = (store: Store<{}>) => {
    store.dispatch(layoutActionCreators.setInitalLoadState(true));
    setTimeout(() => {
        store.dispatch(layoutActionCreators.setInitalLoadState(false));
    }, 0);
};

const configureStore = (middleware: Middleware<{}, unknown, Dispatch<AnyAction>>[], history: History) => {
    const middlewareList = [...middleware, routerMiddleware(history)];

    const store = createStore(rootReducer(history), {}, composeEnhancers(applyMiddleware(...middlewareList)));

    SignalRHandler.initialize(store.dispatch);

    history.listen(() => {
        setState(store);
    });

    setState(store);

    if (process.env.NODE_ENV !== 'production') {
        if (module.hot) {
            module.hot.accept('./reducers', () => {
                store.replaceReducer(rootReducer(history));
            });
        }
    }

    return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store.ts